var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_222",
    "data-name": "Rect\\xE1ngulo 222",
    width: 20,
    height: 20,
    transform: "translate(754 700)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 12.938,
    height: 12.941,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_33",
    "data-name": "Enmascarar grupo 33",
    transform: "translate(-754 -700)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(757.552 703.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M5.476,44.681H1.838A1.745,1.745,0,0,1,0,42.848Q0,39.2,0,35.555a1.742,1.742,0,0,1,1.815-1.823q2.542,0,5.084,0a.5.5,0,0,1,.541.429.5.5,0,0,1-.465.565c-.052,0-.1,0-.155,0H1.844a.758.758,0,0,0-.849.84q0,3.639,0,7.278a.758.758,0,0,0,.834.84H9.121a.755.755,0,0,0,.83-.828q0-2.768,0-5.536a.977.977,0,0,1,.014-.216.5.5,0,0,1,.98.094c0,.021,0,.041,0,.062q0,2.83,0,5.661a1.722,1.722,0,0,1-1.339,1.707,2.093,2.093,0,0,1-.477.05c-1.218,0-2.436,0-3.654,0",
    transform: "translate(0 -31.74)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M91.315,1.708c-.064.06-.105.1-.144.135Q88.213,4.8,85.256,7.76a.519.519,0,0,1-.557.178.494.494,0,0,1-.231-.794c.036-.044.079-.083.119-.123L90.459,1.15c.04-.04.088-.073.132-.109L90.577,1h-.156c-.695,0-1.389,0-2.084,0a.5.5,0,0,1-.5-.44.5.5,0,0,1,.375-.538A.759.759,0,0,1,88.394,0h3.359a.506.506,0,0,1,.557.56q0,1.68,0,3.36a.5.5,0,1,1-.995.005q0-1.019,0-2.037Z",
    transform: "translate(-79.372 0)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenLink);
export default __webpack_public_path__ + "static/media/icon_open_link.f8a884b8cd4aeed03ad0f4e00a6779b1.svg";
export { ForwardRef as ReactComponent };